import { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { loadSavedUsername, saveUsername } from '../utils/loginCredentials';

function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, loading, login } = useAuth();
  const [form, setForm] = useState(() => ({
    username: loadSavedUsername(),
    password: '',
  }));
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const redirectPath = location.state?.from?.pathname || '/posts';

  if (loading) {
    return <div className="auth-loading">로그인 상태를 확인하는 중...</div>;
  }

  if (isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setError('');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');

    try {
      const username = form.username.trim();
      await login(username, form.password);
      saveUsername(username);
      navigate(redirectPath, { replace: true });
    } catch (submitError) {
      setError(submitError.message || '로그인에 실패했습니다.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <h1>Local AS 로그인</h1>
        <p className="login-description">계정으로 로그인하면 AS 관리 기능을 사용할 수 있습니다.</p>

        <label className="field" htmlFor="username">
          <span className="field-label">아이디</span>
          <input
            id="username"
            name="username"
            type="text"
            autoComplete="username"
            value={form.username}
            onChange={handleChange}
            required
          />
        </label>

        <label className="field" htmlFor="password">
          <span className="field-label">비밀번호</span>
          <input
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            value={form.password}
            onChange={handleChange}
            required
          />
        </label>

        {error ? <p className="login-error">{error}</p> : null}

        <button type="submit" disabled={submitting}>
          {submitting ? '로그인 중...' : '로그인'}
        </button>
      </form>
    </div>
  );
}

export default LoginPage;
